import type { GraphEntityType, GraphReadNode } from "@salesko/contracts";

export function savedFrameSearchResults(
  items: GraphReadNode[],
  options: {
    currentFrameRecordId: string | null;
    currentSearchResultIds: string[];
    enabledEntityTypes: GraphEntityType[];
  }
) {
  const enabledTypes = new Set(options.enabledEntityTypes);
  const currentSearchResultIds = new Set(options.currentSearchResultIds);

  return items.filter((node) => {
    if (!enabledTypes.has(node.entityType)) {
      return false;
    }

    return !(node.frameRecordId === options.currentFrameRecordId && currentSearchResultIds.has(node.id));
  });
}

export function savedFrameSearchSubtitle(node: GraphReadNode) {
  return node.summary ?? node.evidence ?? `${node.entityType} in ${shortFrameRecordId(node.frameRecordId)}`;
}

export function shortFrameRecordId(frameRecordId: string) {
  return frameRecordId.length <= 12 ? frameRecordId : `${frameRecordId.slice(0, 8)}...${frameRecordId.slice(-4)}`;
}
